import { AfterViewInit, Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {NavigationLink} from '../../model/navigation-link';
import {RatingUnitService} from '../../services/rating-unit.service';
import {Subscription} from 'rxjs';
import {TermsAcknowledgmentService} from '../../services/terms-acknowledgment.service';
import {DialogService} from '../../services/dialog.service';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {PersonLoginService} from '../../services/person-login-service';

import {MatTabLink, MatTabNav, MatTabNavPanel} from '@angular/material/tabs';

@Component({
    selector: 'app-ratings-home',
    templateUrl: './ratings-home.component.html',
    styleUrls: ['./ratings-home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class RatingsHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly ratingsService = inject(RatingUnitService);
  private readonly termsService = inject(TermsAcknowledgmentService);
  private readonly dialogService = inject(DialogService);
  private readonly router = inject(Router);
  private readonly personLoginService = inject(PersonLoginService);


  readonly navLinks = signal<NavigationLink[]>(undefined!);
  readonly unitListSize = signal<number>(0);
  private unitSizeSubscription!: Subscription;

  ngOnInit(): void {
    if (!this.termsService.areRatingTermsAcknowledged()) {
      this.dialogService.showRatingsTermsDialog().subscribe({
        next: (response) => {
          if (!response) {
            this.router.navigate(['/']);
          } else {
            this.initialize();
          }
        }
      });
    } else {
      this.initialize();
    }
  }

  private initialize(): void {
    this.navLinks.set([
      {path: 'ratingTool', label: 'Quick Rate', image: undefined},
      {path: 'selectionTool', label: 'Selection Tool', image: undefined},
      {path: 'unitList', label: 'Working Unit List', image: undefined},
      {path: 'projectList', label: 'Schedules', image: undefined},
      {path: 'documentation', label: 'Documentation', image: undefined}
    ]);
    if (this.personLoginService.isBetaTester() || this.personLoginService.isAdmin()) {
      this.navLinks.update(current => [...current, {path: 'sureflowLoops', label: 'Loops', image: 'assets/SFLogo.png'}]);
    }
    this.ratingsService.getUnits().subscribe({
      next: (units) => this.unitListSize.set(units.length)
    });
  }

  ngAfterViewInit() {
    this.unitSizeSubscription = this.ratingsService.listSizeChanged().subscribe({
      next: () => {
        this.ratingsService.getUnits().subscribe({
          next: (units) => this.unitListSize.set(units.length),
          error: () => this.unitSizeSubscription.unsubscribe()
        });
      }, error: () => this.unitSizeSubscription.unsubscribe()
    });
  }

  ngOnDestroy() {
    if (this.unitSizeSubscription && !this.unitSizeSubscription.closed) {
      this.unitSizeSubscription.unsubscribe();
    }
  }

}
